export default __webpack_public_path__ + "static/media/susersicon.1386cee5.svg";